import React from 'react';

import Directory from '../../components/directory/directory.component';

const HomePage = () => {
   return (
      <>
         <Directory  />
      </>
   );
}

export default HomePage;